module.exports = __webpack_public_path__ + "static/img/img2.d7b2bad.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/img2.png
// module id = Qlxi
// module chunks = 0